import { PureComponent } from 'react';

declare global {
  interface Window {
    Raven: any,
  }
}

interface SentryReportingProps {
  children: any;
}

export function reportError(error: any, errorInfo: any) {
  if (window.Raven && typeof window.Raven.captureException === 'function') {
    window.Raven.captureException(error, errorInfo);
  }
}

export default class SentryReporter extends PureComponent<SentryReportingProps> {
  componentDidCatch(error: any, errorInfo: any) {
    this.setState({
      error,
    });

    reportError(error, errorInfo);
  }

  render() {
    return this.props.children;
  }
}



// WEBPACK FOOTER //
// ./app/javascript/utils/sentry_reporter.ts